<template>
  <BaseCard :class="classes">
    <div class="BannerCard__media">
      <DynamicImage
        class="BannerCard__image"
        v-bind="$attrs"
        :rounded="false"
      />
    </div>

    <div class="BannerCard__content">
      <BaseHeading
        v-if="heading.text"
        class="BannerCard__heading"
        :class="{ 'BannerCard__heading--wrap': isSmallHeading }"
        :size="headingSize"
        tag="h2"
      >
        <!-- eslint-disable-next-line vue/no-v-html -->
        <span v-html="parseText($tr(heading.text))" />
      </BaseHeading>

      <RichText
        v-if="copy"
        class="BannerCard__copy"
        size="h4"
        :content="parseText(copy)"
      />
    </div>
  </BaseCard>
</template>

<script>
import headingMixin from '~/mixins/headingMixin'
import parseTextMixin from '~/mixins/parseTextMixin'

export default {
  mixins: [headingMixin, parseTextMixin],

  inheritAttrs: false,

  props: {
    copy: {
      type: String,
      default: '',
    },

    primaryColour: {
      type: String,
      default: 'white',
      validator: (value) => {
        return ['white', 'black'].includes(value)
      },
    },
  },

  computed: {
    isSmallHeading() {
      return ['h3', 'h4', 'h5'].includes(this.headingSize)
    },

    classes() {
      return {
        BannerCard: true,
        [`Banner--${this.primaryColour}`]: this.primaryColour,
      }
    },
  },
}
</script>

<style lang="postcss">
.BannerCard {
  position: relative;
  height: 100%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  @screen mdMax {
    min-height: 90vw;
  }
}

.BannerCard__media {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 100%;

  & img {
    height: 100%;
    object-fit: cover;
  }
}

.BannerCard__content {
  position: relative;
  z-index: 1;

  @apply p-6 xl:p-8;
}

.Banner--black {
  color: theme('colors.off-black');
}

.Banner--white {
  color: theme('colors.white');
}
</style>
